<template>
    <div class="comprehensive-analysis">
        <OptionCard
            style="overflow: visible;"
            :help="true"
                :info="{ title: '综合分析', desc: `${pageParams.startDateTime}~${pageParams.endDateTime}`, label: pageParams.dateLabel}"
                load-component-name="statistics-comprehensive-analysis"
                key="comprehensive-analysis"
                :actions="['refresh', 'download', 'setting']"
                @refresh="refresh"
                @download="download"
                @setting="handleSetting"
        >
            <OptionPanelGroup
                    :loading="loadingPanel"
                    :current-select.sync="currentSelect"
                    :data="comprehensiveReview"
                    :number-color="originA.trafficError?'#F5222D':null"
                    @openSetting="handleSetting"
                    @update:currentSelect="selectOption"
            />
            <el-row type="flex" justify="space-between" :gutter="10">
                <el-col :span="24">
                    <OptionCard hide-header  key="comprehensive-analysis-ring" style="overflow: visible;">
                        <el-row type="flex" justify="space-between">
                            <el-col :span="12">
                                <gj-select :clearable="false" v-model="form.compareValue" :options="comparisonMethodOptions" @change="handleCompareValueChange"/>
                                <gj-select
                                    v-show="form.compareValue === 1"
                                    v-model="form.targetValue"
                                    :options="indexComparisonOptions"
                                    :clearable="false"
                                    :width="'200px'"
                                    :type="'multi-check'"
                                    style="padding-left: 10px"
                                >
                                </gj-select>
                            </el-col>
                            <el-col :span="12" class="flex justify-end">
                                <gj-radio-group
                                        v-model="form.dateStatus"
                                        :options="dateOptions" @change="getComprehensiveAnalysisLine">
                                </gj-radio-group>
                            </el-col>
                        </el-row>
                        <el-row v-loading="loading">
                            <ve-line
                                    height="288px"
                                    :data-empty="chartData.empty"
                                    :data="chartData.data"
                                    :settings="chartData.settings"
                                    :extend="chartData.options"
                                    :loading="loading">
                            </ve-line>
                        </el-row>
                    </OptionCard>
                </el-col>
            </el-row>
        </OptionCard>
    </div>
</template>

<script>
    import {
        getComprehensiveAnalysisReview,
        getComprehensiveAnalysisLine,
        getComprehensiveAnalysisExport
    } from '@/api/statistics'

    import _ from "lodash";
    import {
        comparisonMethodOptions,
        indexComparisonOptions,
        DATE_OPTIONS,
    } from "@/utils/options"
    import {exportFile, getCustomColumns} from "@/api/common";
    import { ASIN_361_MODULE_COMPREHENSIVE } from "@/utils/const";
    import {
        DEFAULT_CHARTS_DATA,
        generatorLineChartsData,
        generatorToolTip,
        generatorLineTimeCompareToolTip
    } from "@/views/modules/statistics/asin-361-analysis/config";
    import MaxStack from '@/utils/max-stack'

    import OptionCard from '@/views/components/option-card/option-card'
    import OptionPanelGroup from '@/views/components/option-panel-group/option-panel-group'

    export default {
        name: "statistics-comprehensive-analysis",
        inject: ['getPageParams', 'generatorPageParams'], // 全局查询参数
        data () {
            return {
                comprehensiveReview: [],
                comparisonMethodOptions,
                indexComparisonOptions,
                DATE_OPTIONS,
                statisticsData: [], // 统计数据
                thenData: [], // 环比数据
                operationLogVOList: [], // 运营数据
                originA: {},
                originB: {},
                moduleColumns: [
                    {label: "销量", key: "unitsOrdered", sortIndex: 0, default: true },
                    {label: "销量-B2B", key: "unitsOrderedB2b", sortIndex: 1 },
                    {label: "销售额", key: "orderProductSales", prefix: 'currencySymbol',sortIndex: 2, default: true },
                    {label: "销售额-B2B", key: "orderProductSalesB2b", prefix: 'currencySymbol',sortIndex: 3 },
                    {label: "订单量", key: "orders", sortIndex: 4, default: true},
                    {label: "退款量", key: "refunds", sortIndex: 5},
                    {label: "退款率", key: "refundsRate", suffix: '%', sortIndex: 6 },
                    {label: "退款销售额", key: "returnProductSales", prefix: 'currencySymbol',sortIndex: 7 },
                    {label: "退货量", key: "returns", sortIndex: 8 },
                    {label: "退货率", key: "returnsRate", suffix: '%', sortIndex: 9 },
                    // {label: "平均订单商品种类数", key: "avgOrderItems", sortIndex: 10 },              //这个指标暂时隐藏
                    {label: "平均订单价格", key: "avgUnitsOrderedSales", prefix: 'currencySymbol',sortIndex: 11 },
                    {label:'Sessions-移动端',key:'sessionsMobile',sortIndex:38},
                    {label:'Sessions-PC端',key:'sessionsBrowser',sortIndex:39},
                    {label:'Sessions-总计',key:'sessions',sortIndex:30},
                    {label:'CVR',key:'unitSessionPercentage',suffix: '%',sortIndex:31},
                    {label:'PV-移动端',key:'pageViewsMobile',sortIndex:40},
                    {label:'PV-PC端',key:'pageViewsBrowser',sortIndex:41},
                    {label:'PV-总计',key:'pageViews',sortIndex:32},
                    {label:'Buybox',key:'buyBoxPercentage',suffix: '%',sortIndex:33},
                    {label:'大类排名',key:'mainCategoryRank',sortIndex:34},
                    {label:'小类排名',key:'subCategoryRank',sortIndex:35},
                    {label:'Review中差评',key:'midBadReview',sortIndex:36},
                    {label:'评分',key:'star',sortIndex:37},

                    {label: "曝光量", key: "adsImpressions", sortIndex: 12 },
                    {label: "点击量", key: "adsClicks", sortIndex: 13, default: true },
                    {label: "CTR", key: "ctr",suffix: '%', sortIndex: 14 },
                    {label: "广告花费", key: "adsSpend", sortIndex: 15, prefix: 'currencySymbol',default: true },
                    {label: "CPC", key: "cpc", prefix: 'currencySymbol',sortIndex: 16 },
                    {label: "广告订单量", key: "adsOrders", sortIndex: 17 },
                    {label: "广告CVR", key: "cr", suffix: '%',sortIndex: 18, default: true },
                    {label: "广告销售额", key: "adsSales",prefix: 'currencySymbol', sortIndex: 19 },
                    {label: "ACOS", key: "acoS", suffix: '%',sortIndex: 20 },
                    {label: "ACOAS", key: "acoAS", suffix: '%',sortIndex: 21 },
                    {label: "ASOAS", key: "asoAS", suffix: '%',sortIndex: 22 },
                    {label: "ROAS", key: "roAS", suffix: '%',sortIndex: 23 },
                    {label: "总收入", key: "totalIncome", prefix: 'currencySymbol',sortIndex: 24 },
                    {label: "总支出", key: "totalExpenditure", prefix: 'currencySymbol',sortIndex: 25 },
                    {label: "销售毛利", key: "salesGrossProfit", prefix: 'currencySymbol',sortIndex: 26, default: true },
                    {label: "销售毛利率", key: "grossProfitRate", suffix: '%',sortIndex: 27 , default: true},
                    {label: "销售净毛利", key: "salesNetProfit", prefix: 'currencySymbol',sortIndex: 28 },
                    {label: "销售净毛利率", key: "salesNetProfitRate", suffix: '%',sortIndex: 29 },
                ],
                form: { // select筛选项
                    targetValue: ['orderProductSales'],
                    compareValue: 0,
                    dateStatus: 'DAY'
                },
                currentSelect: { // 当前选中的panel项
                    key: '',
                    value: '',
                    label: '',
                    percent: ''
                },
                loading: false,
                loadingPanel: false,
                noData: false
            }
        },
        components: {
            OptionCard,
            OptionPanelGroup
        },
        computed: {
            pageParams () {
                return this.getPageParams()
            },
            dateOptions ({ form, currentSelect, DATE_OPTIONS }) {
                const arr = ['orders', 'orderProductSales', 'unitsOrdered']
                return (form.compareValue === 0 && !arr.includes(currentSelect.key) || (form.compareValue === 1 && form.targetValue.some(v => !arr.includes(v)))) ? DATE_OPTIONS.filter(v => v.id !== 'HOURS') : DATE_OPTIONS
            },
            chartData ({ currentSelect, statisticsData = [], thenData = [], form, moduleColumns = [], operationLogVOList = [] }) {
                return form.compareValue === 0 ? this.generateLineData(statisticsData, thenData, currentSelect, moduleColumns, operationLogVOList) : this.generatorLineKeyData(statisticsData, thenData, currentSelect, form.targetValue, moduleColumns, operationLogVOList)
            }
        },
        created () {

            this.getComprehensiveAnalysisReview()
            this.getComprehensiveAnalysisLine()
        },
        methods: {
          selectOption(item){
            this.form.targetValue = Array.from(new Set(this.form.targetValue.concat([item.key])))
          },
            /**
             * 获取综合分析概览
             */
            getComprehensiveAnalysisReview () {
                let params = this.generatorPageParams(this.pageParams)
                params.dateType = this.form.dateStatus
                getComprehensiveAnalysisReview(params).then(({
                   asin361ComprehensiveAnalysisDetailVO: originalA,
                   asin361ComprehensiveAnalysisDetailVOThen: originalB
                }) => {
                    this.originA = originalA
                    this.originB = originalB
                    this.getCustomColumns().then(() => {
                        this.comprehensiveReview = this.generatorData(originalA, originalB, this.comprehensiveReview)
                    })
                })
            },
            /**
             * 获取折线图数据
             */
            getComprehensiveAnalysisLine () {
                let params = this.generatorPageParams(this.pageParams)
                params.dateType = this.form.dateStatus
                this.loading = true
                getComprehensiveAnalysisLine(params).then(({ statisticsData = [],  thenData = [], operationLogVOList = []}) => {
                    this.operationLogVOList = operationLogVOList
                    this.statisticsData = statisticsData
                    this.thenData = thenData
                }).complete(() => this.loading = false)
            },
            /**
             * 映射数据
             * @param originalA 概览数据
             * @param originalB 环比数据
             * @param mapData 映射数组
             * @returns {*[]}
             */
            generatorData (originalA, originalB, mapData) {
                if (!originalA || !originalB || !mapData || !mapData.length) return []
                return mapData.map(v => {
                    return Object.assign(v,{
                        label: v.label,
                        key: v.key,
                        value: originalA[v.key],
                        percent: ((originalA[v.key] - originalB[v.key]) / Math.abs(originalB[v.key]) * 100).toFixed(2),
                        currencySymbol: originalB.currencySymbol
                    })
                })
            },
            /**
             * 映射折线图数据 - 时间对比
             * @param statisticsData 统计数据
             * @param thenData 环比数据
             * @param currentSelect 当前选中panel项
             * @returns {{columns: [string], rows: *}}
             */
            generateLineData (statisticsData = [], thenData = [], currentSelect, moduleColumns = [], operationLogVOList = []) {

                if (!statisticsData.length || !thenData.length || !currentSelect || !currentSelect.key) return DEFAULT_CHARTS_DATA

                const form = this.form
                let columns = ['dateLine', 'value', 'compare']
                let { key = '' } = currentSelect
                let showPercentColumn = []
                let showCurrencySymbol = []
                let labelMap = {
                    dateLine: '日期',
                    value: '统计时间',
                    compare: '对比时间'
                }
                let { currencySymbol = '' } =  statisticsData.find(v => v.currencySymbol) || {}

                if (currentSelect && currentSelect.suffix) {
                    showPercentColumn.push(key)
                } else if (currentSelect && currentSelect.prefix) {
                    showCurrencySymbol.push(key)
                }

                let rows = statisticsData.map((v, i) => {
                    return ({
                        'dateLine': v['dateLine'],
                        'value': v[key],
                        'compare': thenData[i] ? thenData[i][key] : 0
                    })
                })

                let options = generatorLineChartsData()

                options.tooltip = {
                    formatter: generatorLineTimeCompareToolTip(showPercentColumn, showCurrencySymbol, labelMap, currencySymbol, statisticsData, thenData, form.dateStatus === 'DAY' ? operationLogVOList : [])
                }

                options.yAxis = {
                    splitNumber: 8,
                    axisLabel: {
                        formatter(value) {
                            return showPercentColumn.length ? `${value}%` : `${value}`
                        }
                    }
                }

                return {
                    data: {
                        columns,
                        rows
                    },
                    settings: {
                        labelMap
                    },
                    options,
                    empty: !rows.length
                }
            },
            /**
             * 映射折线图数据 - 指标对比
             */
            generatorLineKeyData (statisticsData = [], thenData = [], currentSelect, targetValue = [], moduleColumns = [], operationLogVOList = []) {

                if (!statisticsData.length || !thenData.length || !currentSelect || !currentSelect.key)  return DEFAULT_CHARTS_DATA
                let columns = ['dateLine']
                if (targetValue && targetValue.length) columns.push(...targetValue)
                let labelMap = {
                    dateLine: '日期'
                }
                const form = this.form
                let showPercentColumn = []
                let showCurrencySymbol = []
                let rows = statisticsData.map(v => {
                    let param = {
                        dateLine: v.dateLine
                    }

                    if (targetValue && targetValue.length) {
                        targetValue.forEach(k => {
                            labelMap[k] = this.findText(k).text || k
                            let findColumn = moduleColumns.find(p => p.key === k)
                            if (findColumn && findColumn.suffix === '%') {
                                showPercentColumn.push(k)
                            }

                            if (findColumn && findColumn.prefix === 'currencySymbol') {
                                showCurrencySymbol.push(k)
                            }

                            param[k] = showPercentColumn.includes(k) ? !isNaN(v[k]) ? v[k] / 100 : v[k] : v[k]
                        })
                    }

                    return param
                })

                const stackLeft = new MaxStack()
                const stackRight = new MaxStack()

                for (let item of rows) {
                    Object.keys(item).forEach(v => {
                        if (v !== 'dateLine') {
                            const number = item[v] ? parseFloat(item[v]) : 0
                            !showPercentColumn.includes(v) ? stackLeft.push(number) : stackRight.push(number)
                        }
                    })
                }

                const leftMaxY = stackLeft.getMax()
                const rightMaxY = stackRight.getMax() || 1

                let { currencySymbol = '' } = statisticsData.find(v => v.currencySymbol) || {}
                let options = generatorLineChartsData()
                options.tooltip = {
                    formatter: generatorToolTip(showPercentColumn, showCurrencySymbol, labelMap, currencySymbol, form.dateStatus === 'DAY' ? operationLogVOList : [])
                }

                options.yAxis = (item) => {
                    item[0].splitNumber = 5
                    item[0].interval = Math.ceil(leftMaxY / 5)
                    item[0].min = 0
                    item[0].max = Math.ceil(leftMaxY / 5) * 5
                    item[1].splitNumber = 5
                    item[1].interval = rightMaxY > 1 ? Math.ceil((rightMaxY * 100) / 5) / 100 : 1 / 5
                    item[1].min = 0
                    item[1].max = rightMaxY > 1 ? (Math.ceil((rightMaxY * 100) / 5) * 5) / 100 : 1
                    return item
                }

              options.series.type = 'line';

                return {
                    data: {
                        columns,
                        rows
                    },
                    settings: {
                        labelMap,
                        yAxisType: ['normal', 'percent'],
                        axisSite: {
                            right: showPercentColumn
                        },
                    },
                    options,
                    empty: !rows.length
                }

            },
            findText (key) {
                return this.indexComparisonOptions.find(p => p.id === key) || {}
            },
            /**
             * 加载自定义列
             */
            getCustomColumns(){
                this.loadingPanel = true
                return getCustomColumns(ASIN_361_MODULE_COMPREHENSIVE).then(res =>{
                    let list = res ? res.split(",") : null;
                    this.comprehensiveReview = !_.isEmpty(list) ? this.moduleColumns.filter(e=> _.includes(list, e.key)) : this.moduleColumns.filter(e=> e.default);
                    this.moduleColumns = !_.isEmpty(list) ? this.moduleColumns.map(e => {
                        if (_.includes(list, e.key)){
                            e.checked = true;
                        }
                        return e;
                    }) : this.moduleColumns.map(e => {
                        if (e.default){
                            e.checked = true;
                        }
                        return e;
                    })
                }).complete(() => this.loadingPanel = false)
            },
            /**
             * 对比选项切换
             * @param id 当前选择项
             */
            handleCompareValueChange (id) {
                this.form.targetValue = [this.currentSelect.key]
            },
            /**
             * 打开设置看板
             */
            handleSetting () {
                this.$gjCreate('gj-setting-custom-modal', {
                    props: {
                        name: ASIN_361_MODULE_COMPREHENSIVE,
                        size: 'middle',
                        moduleColumns: this.moduleColumns,
                        allowNum: 8,
                        customStr: "unitsOrdered,unitsOrderedB2b,orderProductSales,orderProductSalesB2b,orders,refunds,refundsRate," +
                            "returnProductSales,returns,returnsRate,avgOrderItems,avgUnitsOrderedSales,adsImpressions,adsClicks,ctr,adsOrders," +
                            "adsSales,cr,adsSpend,cpc,acoS,roAS,asoAS,acoAS,"+
                            "totalIncome,totalExpenditure,salesGrossProfit,grossProfitRate,salesNetProfit,salesNetProfitRate"
                    },
                    on: {
                        ["moduleColumns"]: moduleColumns => {
                            this.moduleColumns = moduleColumns;
                        },
                        ['check-list-items']: columns => {
                            this.comprehensiveReview = this.generatorData(this.originA, this.originB, columns)
                            this.refresh()
                        }
                    }
                })
            },
            /**
             * 导出
             */
            download () {
                const templateUrl = "/operation/asin361/comprehensive/export";
                const templateParams = this.generatorPageParams(this.pageParams)
                templateParams.dateType = this.form.dateStatus
                exportFile(templateUrl, templateParams)
                    .complete(() => this.templateDownloadLoading = false);
            },
            /**
             * 刷新组件
             */
            refresh () {
                this.getComprehensiveAnalysisReview()
                this.getComprehensiveAnalysisLine()
            }
        },
        watch: {
            currentSelect: {
                immediate: true,
                deep: true,
                handler(val, oldValue) {
                    if (val && val.key && val.key !== oldValue.key) {
                        const arr = ['orders', 'orderProductSales', 'unitsOrdered']
                        if (this.form.compareValue === 0 && !arr.includes(val.key)) {
                            this.form.dateStatus = 'DAY'
                        }

                    }
                }
            },
            'form.targetValue': {
                immediate: true,
                handler(val, oldValue) {
                    const arr = ['orders', 'orderProductSales', 'unitsOrdered']
                    if (this.form.compareValue === 1 && val.some(v => !arr.includes(v))) {
                        this.form.dateStatus = 'DAY'
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .comprehensive-analysis {

    }
</style>
